export class Position {
    private x: number;
    private y: number;

    constructor(x: number, y: number) {
        this.setX(x);
        this.setY(y);
    }

    static fromJSON(json: any) {
        return new Position(json.x, json.y);
    }

    setX(newX: number) {
        this.x = newX;
    }
    setY(newY: number) {
        this.y = newY;
    }

    getX() {
        return this.x;
    }
    getY() {
        return this.y;
    }
}